module.exports = __webpack_public_path__ + "static/media/carpenter.a76e0a1e.jpeg";